import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import {
  MODULES_KEY,
  PERMISSION_OBJECT,
  ROUTES_MODULES_KEY,
} from '../../common/constants';
import Booking from './Booking';
import Listing from './Listing';
import ListingForm from './ListingForm';
import './assetsManagement.less';

const assetsWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.ASSETS_LISTING}`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.ASSETS_LISTING}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <Listing {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.ASSETS_BOOKING}`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.ASSETS_BOOKING}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <Booking {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.ASSETS_LISTING}/add`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.ASSETS_LISTING}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <ListingForm {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.ASSETS_LISTING}/edit/:assetById`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.ASSETS_LISTING}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <ListingForm {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);

export default assetsWrapper;
